
export const runValidateFields = (field, value) => {

    switch (field) {
        case "email":
            console.log('llego aqui');
            let validationResponse = validarEspaciosEnBlanco(field, value);
            return validationResponse;

        default:
            break;
    }


}

export const validarSoloNumeros = (value = "") => {
    let isValid = false;
    if (value.length <= 0) {
        return isValid;
    }
    let ExpRegSoloNumeros = "^[0-9]+$";
    let regexField = value.match(ExpRegSoloNumeros)
    if (regexField !== null) {
        isValid = true;
    }

    return isValid;
}


export const validarEspaciosEnBlanco = (field, value = "") => {
    let message;
    let isError = false

    if (value.indexOf(" ") !== -1) {
        console.log(`El ${field} no puede contener espacios en blanco`);
        message = `El ${field} no puede contener espacios en blanco`;
        isError = true;
        return [isError, message];
    }
    message = "";
    return [isError, message]
}

export const removeAccents = (value = "") => {
    if (value.length <= 0) {
        return value
    }
    let value2 = value.normalize("NFD").replace(/\p{Diacritic}/gu, "");
    return value2
}

export const removeSpecialCharsAndEmojis = (str) => {
    return str.replace(/[^a-zA-Z0-9\s]/g, '');
}
